import { db, FirebaseDocRefType } from 'firebase/index'
import { getConverter } from 'lib/firestore'
import { PointCardUserOfferType as BasicPointCardUserOfferType } from 'types/pointCard/pointCardUserOffer'

type PointCardUserOfferType = BasicPointCardUserOfferType & { ref: FirebaseDocRefType }

const PointCardUserOfferConverter = getConverter<PointCardUserOfferType>()

export const fetchPointCardUserOffer = (
  pointCardId: string,
  pointCardUserId: string,
  id: string
): Promise<PointCardUserOfferType | undefined> => {
  return db
    .collection('point_cards')
    .doc(pointCardId)
    .collection('point_card_users')
    .doc(pointCardUserId)
    .collection('point_card_user_offers')
    .doc(id)
    .withConverter(PointCardUserOfferConverter)
    .get()
    .then((snapshot) => {
      const data = snapshot.data()
      if (!data) {
        return undefined
      }
      return {
        ...data,
        ref: snapshot.ref,
      }
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchPointCardUserOffers = (
  pointCardId: string,
  pointCardUserId: string
): Promise<PointCardUserOfferType[]> => {
  return db
    .collection('point_cards')
    .doc(pointCardId)
    .collection('point_card_users')
    .doc(pointCardUserId)
    .collection('point_card_user_offers')
    .withConverter(PointCardUserOfferConverter)
    .orderBy('created_at', 'asc')
    .get()
    .then((snapshots) =>
      snapshots.docs.map((snapshot) => {
        const data = snapshot.data()
        return {
          ...data,
          ref: snapshot.ref,
        }
      })
    )
    .catch((error) => {
      console.error(error)
      return []
    })
}

export const fetchPointCardUserOffersByOfferRef = (
  pointCardOfferRef: FirebaseDocRefType
): Promise<PointCardUserOfferType[]> => {
  return db
    .collectionGroup('point_card_user_offers')
    .withConverter(PointCardUserOfferConverter)
    .where('point_card_offer_ref', '==', pointCardOfferRef)
    .orderBy('created_at', 'asc')
    .get()
    .then((snapshots) =>
      snapshots.docs.map((snapshot) => {
        const data = snapshot.data()
        return {
          ...data,
          ref: snapshot.ref,
        }
      })
    )
    .catch((error) => {
      console.error(error)
      return []
    })
}

export const setPointCardUserOffer = (pointCardUserOffer: PointCardUserOfferType): Promise<void> => {
  const { ref, ...rest } = pointCardUserOffer
  return ref.set(rest, { merge: true })
}
